import script from "./GameCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GameCard.vue?vue&type=script&setup=true&lang=js"

import "../styles/_card.scss?vue&type=style&index=0&id=6c7fedc4&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7fedc4"]])

export default __exports__